export default {
    primary: '#191970',
    secondary: '#5956fb',
    tertiary: '#f4f4f4',
    quaternary: '#4a70d9',
    fifth: '#413db5',
    sixth: '#b62575',
    seventh: '#66257f',
}
